import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { HolidayItem } from "@/services/entities/HolidayItem";
import { useSettingsStore } from "@/stores/setting";
import { useVfm, VueFinalModal } from "vue-final-modal";
import ConfirmModal from "./ConfirmModal.vue";
import HolidayForm from "@/components/holiday/HolidayForm.vue";
import { reactive } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HolidayModal',
  props: ['value', 'isCreate'],
  emits: ["create", "close", "edit"],
  setup(__props, { emit: __emit }) {

const vfm = useVfm();
const confirmModalId = Symbol("editConfirmModalId");
const settingsStore = useSettingsStore();
const emit = __emit;

const props = __props;
function beforeClose() {
    vfm.open(confirmModalId);
}

function create() {
    emit("create");
}

function edit() {
    emit("edit");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: false,
    onClickOutside: beforeClose
  }, {
    default: _withCtx(() => [
      _createVNode(HolidayForm, {
        value: props.value
      }, {
        buttons: _withCtx(() => [
          (props.isCreate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (props.value.push({ date: new Date() } as HolidayItem)))
                }, "Add next"),
                _createElementVNode("button", {
                  class: "accent",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (create()))
                }, "Save holidays")
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "accent",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (edit()))
              }, "Save changes"))
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(ConfirmModal, {
        "modal-id": _unref(confirmModalId),
        text: "You have unsaved changes, do you really want to leave this form?",
        "confirm-text": "Close form",
        onConfirm: _cache[3] || (_cache[3] = () => {
                _unref(vfm).close(_unref(confirmModalId));
                emit('close');
            }
                ),
        onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(vfm).close(_unref(confirmModalId))))
      }, null, 8, ["modal-id"])
    ]),
    _: 1
  }))
}
}

})